module.exports = __webpack_public_path__ + "assets/img/img214.a72b9e00.png";